import { render, staticRenderFns } from "./ThemeTab.vue?vue&type=template&id=bf43f32e&scoped=true&"
import script from "./ThemeTab.vue?vue&type=script&lang=js&"
export * from "./ThemeTab.vue?vue&type=script&lang=js&"
import style0 from "./ThemeTab.vue?vue&type=style&index=0&id=bf43f32e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf43f32e",
  null
  
)

export default component.exports